"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const logos = [{
  id: 1,
  name: "Marcus Thorne",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_1.png"
}, {
  id: 2,
  name: "Elena Rossi",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_2.png"
}, {
  id: 3,
  name: "Julian Vane",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_3.png"
}, {
  id: 4,
  name: "Sophia Chen",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_4.png"
}, {
  id: 5,
  name: "Alistair Cook",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_5.png"
}, {
  id: 6,
  name: "Beatrice Wood",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_6.png"
}, {
  id: 7,
  name: "Dominic West",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_7.png"
}, {
  id: 8,
  name: "Clara Oswald",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_8.png"
}, {
  id: 9,
  name: "Gideon Graves",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_9.png"
}, {
  id: 10,
  name: "Helena Troy",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_10.png"
}, {
  id: 11,
  name: "Silas Marner",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_11.png"
}];
export default function LogoSlider() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    if (!api || isHovered) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [api, isHovered]);
  return;
}